import gql from "graphql-tag";

export const MY_LEAVE_GET_ASSIGNERS_NAME = gql`
  query getAssignersName($contract: String, $product: String, $locale: String) {
    getAssignersName(contract: $contract, product: $product, locale: $locale)
  }
`;
